import './main-navigation.css'
import { defineComponent, watch } from 'vue'
import { useElementSize } from '@vueuse/core'
import { BlockModule } from '@/website/blocks/common'
import {
    Accordion,
    AccordionTrigger,
    AccordionContent,
    AccordionItem,
} from '@/components/ui/accordion'
import { MainNavigation, MobileMainNavigation } from './components'
import { Button } from '@/components/ui/button'
import { useNavContext } from './composables'

new BlockModule({
    selector: '.block-main-navigation',
    vueComponent: defineComponent({
        components: {
            Accordion,
            AccordionTrigger,
            AccordionContent,
            AccordionItem,
            ButtonComponent: Button,
            MainNavigation,
            MobileMainNavigation,
        },
        props: {
            navMode: String,
        },
        setup(props) {
            const { height: mainNavigationHeight } = useElementSize(
                document.querySelector('.block-main-navigation') as HTMLElement,
            )
            watch(mainNavigationHeight, (val) => {
                document.body.style.setProperty('--egnc-navigation-root-height', val + 'px')
            })
            const { isSolidColorNav, isOverlayNav, isNavHidden } = useNavContext(props.navMode)

            return {
                isSolidColorNav,
                isOverlayNav,
                isNavHidden,
            }
        },
    }),
})
